import React, { useState, useEffect } from "react";
import Header from "@cloudscape-design/components/header";
import { fetchUserAttributes } from "aws-amplify/auth";

const HeaderComponent = React.memo(function HeaderComponent() {
  const [attrs, setAttrs] = useState({
    family_name: "unknown",
    given_name: "unknown",
    email: "unknown",
  });

  useEffect(() => {
    fetchUserAttributes().then((attributes) => {
      setAttrs({
        family_name: attributes.family_name,
        given_name: attributes.given_name,
        email: attributes.email,
      });
    });
  }, []);

  const alias = attrs.email.replace("@amazon.com", "");

  return (
    <Header
      actions={
        <div>
          {attrs.given_name} {attrs.family_name} ({alias})
        </div>
      }
    >
      CAT Explorer
      <br />
      <div style={{ fontSize: "small" }}>
        Created by the SDO Threat Operations Research and Monitoring (STORM)
        Team
      </div>
    </Header>
  );
});

export default HeaderComponent;
